declare global {
  interface Window {
    Paddle?: {
      Environment: { set: (env: string) => void };
      Setup: (config: { token: string }) => void;
      Checkout: { open: (options: { transactionId: string }) => void };
    };
  }
}

let paddleLoading: Promise<void> | null = null;

function loadPaddleScript(): Promise<void> {
  if (window.Paddle) return Promise.resolve();
  if (paddleLoading) return paddleLoading;

  paddleLoading = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Paddle.js 로드에 실패했습니다."));
    document.head.appendChild(script);
  });
  return paddleLoading;
}

export async function openPaddleCheckout(transactionId: string) {
  await loadPaddleScript();
  if (!window.Paddle) throw new Error("Paddle이 초기화되지 않았습니다.");

  const env = import.meta.env.VITE_PADDLE_ENV || "sandbox";
  const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN;
  if (!token) throw new Error("VITE_PADDLE_CLIENT_TOKEN이 설정되지 않았습니다.");

  if (env === "sandbox") window.Paddle.Environment.set("sandbox");
  window.Paddle.Setup({ token });
  window.Paddle.Checkout.open({ transactionId });
}
